import { ZonesManagement } from '@/components/ZonesMangement';
import { DrawerLayout } from '@/layouts/DrawerLayout';
  

export const TasksPage = () => {
  return (
    <DrawerLayout>
      <ZonesManagement />
    </DrawerLayout>
  );
};
